// Master list of all known cost categories. Accounts may opt-in to a subset
// via AccountPreference#enabled_cost_categories — use {filterCategories} or
// {enabledCategoriesFor} to compute the visible list at runtime.
export const COST_CATEGORIES = ["labor", "equipment", "materials", "subcontracting", "other"]

// Returns the categories the account currently exposes. Falls back to the
// master list when the account payload doesn't carry the preference.
// Always keeps `currentValue` in the result so legacy data with a now-disabled
// category stays selectable in the dropdown.
export const enabledCategoriesFor = (account, currentValue) => {
  const fromAccount = account && Array.isArray(account.enabled_cost_categories) ? account.enabled_cost_categories : null
  const base        = (fromAccount && fromAccount.length > 0) ? fromAccount : COST_CATEGORIES
  const filtered    = base.filter(c => COST_CATEGORIES.includes(c))
  if (currentValue && !filtered.includes(currentValue) && COST_CATEGORIES.includes(currentValue)) {
    return [...filtered, currentValue]
  }
  return filtered
}

// Helper for components that already hold the raw list (e.g. recap table).
export const filterCategories = (categories, account) => {
  const enabled = enabledCategoriesFor(account)
  return categories.filter(c => enabled.includes(c))
}

export const CATEGORY_ICONS = {
  labor:          "fas fa-hard-hat",
  equipment:      "fas fa-tools",
  materials:      "fas fa-boxes",
  subcontracting: "fas fa-handshake",
  other:          "fas fa-ellipsis-h",
}

export const CATEGORY_COLORS = {
  labor:          "#3b82f6",
  equipment:      "#8b5cf6",
  materials:      "#10b981",
  subcontracting: "#f59e0b",
  other:          "#6b7280",
}

// New cost-bearing line → default cost_category by type.
// Service lines categorize at the breakdown level, so the line itself stays null.
// Non-cost-bearing types (descriptive, subtotal, section, break, group, blueprint, template, import_csv)
// also return null.
export const defaultCostCategoryFor = (type) => {
  switch (type) {
    case "product":  return "materials"
    case "regular":  return "other"
    default:         return null
  }
}
